window.Sports = (function () {
    const actions = {
        handlers: {
            addSportHandler: function (
                control: any,
                maxCount: number,
                svgNumber: number,
                scope: any
            ) {
                let selectedCount = parseInt(
                    $('span.selected-sports-counter', scope).text()
                );

                if (selectedCount < maxCount) {
                    const data = $(control).data('value');

                    const stringData = $(control).data('stringvalue');

                    $('.icon-sport-' + svgNumber, scope).remove();

                    $('ul.selected-sports__list', scope).append(
                        '<li class="selected-sports__list-item"></li>'
                    );
                    $('ul.selected-sports__list li:last-child', scope).append(
                        '<div class="selected-sports__drag-icon-wrapper"><div class= "selected-sports__drag-icon"></div></div>'
                    );
                    $('ul.selected-sports__list li:last-child', scope).append(
                        '<div class="selected-sports__item-icon">' +
                            app.svgSports(
                                svgNumber,
                                'selected-sports__item-icon'
                            ) +
                            '</div>'
                    );
                    $('ul.selected-sports__list li:last-child', scope).append(
                        '<input type="hidden" name="selectedTypes" value="' +
                            data +
                            '" />'
                    );
                    $('ul.selected-sports__list li:last-child', scope).append(
                        stringData
                    );
                    $('ul.selected-sports__list li:last-child', scope).append(
                        '<div class="settings-bin__sports-wrapper"></div>'
                    );
                    $(
                        'ul.selected-sports__list li:last-child > div.settings-bin__sports-wrapper',
                        scope
                    ).append(
                        '<a data-value="' +
                            data +
                            '"data-stringValue="' +
                            stringData +
                            '" onclick="Sports.actions.handlers.removeSportHandler(this,' +
                            maxCount +
                            ',' +
                            svgNumber +
                            ", '" +
                            scope +
                            "'" +
                            ');">' +
                            Utils.svgHtml('bin', 'settings-bin__sports-icon') +
                            '</a>'
                    );

                    $(control).closest('li').remove();
                    $(control).remove();

                    selectedCount += 1;

                    $('span.selected-sports-counter', scope).html(
                        selectedCount.toString()
                    );
                }
            },
            removeSportHandler: function (
                control: any,
                maxCount: number,
                svgNumber: number,
                scope: any
            ) {
                let selectedCount = parseInt(
                    $('span.selected-sports-counter', scope).text()
                );

                const data = $(control).data('value');

                const stringData = $(control).data('stringvalue');

                $('.icon-sport-' + svgNumber, scope).remove();

                $('ul.available-sports__list', scope).append(
                    '<li class="available-sports__list-item"></li>'
                );
                $('ul.available-sports__list li:last-child', scope).append(
                    '<div class="available-sports__item-icon"></div>'
                );
                $(
                    'ul.available-sports__list li:last-child > div.available-sports__item-icon',
                    scope
                ).append(
                    app.svgSports(
                        svgNumber,
                        'settings-sort__sports-icon m-contrast',
                        scope
                    )
                );
                $('ul.available-sports__list li:last-child', scope).append(
                    '<a onclick="Sports.actions.handlers.addSportHandler(this,' +
                        maxCount +
                        ',' +
                        svgNumber +
                        ", '" +
                        scope +
                        "'" +
                        ');" data-stringValue="' +
                        stringData +
                        '" data-value="' +
                        data +
                        '" >' +
                        stringData +
                        '</a>'
                );

                const listItems = $('ul.available-sports__list > li', scope);

                const s = $(listItems)
                    .detach()
                    .sort(function (a, b) {
                        const contentA = $(a).children('a').text();
                        const contentB = $(b).children('a').text();

                        return contentA < contentB
                            ? -1
                            : contentA > contentB
                            ? 1
                            : 0;
                    });

                s.each(function (index, row) {
                    $('ul.available-sports__list', scope).append(row);
                });

                $(control).closest('li').remove();
                $(control).remove();

                selectedCount -= 1;

                $('span.selected-sports-counter', scope).html(
                    selectedCount.toString()
                );
            },
        },
    };

    return {
        actions,
    };
})();
